import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Box from "@mui/material/Box";
import MuiAlert from "@mui/material/Alert";
import Button from "@mui/material/Button";

const HIDE_DURATION = 3000;

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const Notification = (props = {}) => {
  const { message = "", open = false, type = "", onClose, onInstall } = props;
  return (
    <Box sx={{ width: "100%" }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open && type === "success"}
        autoHideDuration={HIDE_DURATION}
        onClose={onClose}
      >
        <Alert onClose={onClose} severity="success" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open && type === "error"}
        autoHideDuration={HIDE_DURATION}
        onClose={onClose}
      >
        <Alert severity="error">{message}</Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open && type === "warning"}
        autoHideDuration={HIDE_DURATION}
        onClose={onClose}
      >
        <Alert severity="warning">{message}</Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open && type === "install"}
        autoHideDuration={5000}
        onClose={onClose}
      >
        <Alert
          severity="success"
          action={
            <Button onClick={onInstall} color="inherit" size="small">
             ok 
            </Button>
          }
        >
          {message}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open && type === "info"}
        autoHideDuration={HIDE_DURATION}
        onClose={onClose}
      >
        <Alert severity="info">{message}</Alert>
      </Snackbar>
    </Box>
  );
};
